import "./InnerHtmlSVG.module.css";

const InnerHtmlSVG = ({svg}) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: svg }}/>
  );
};

export default InnerHtmlSVG;
